import { render, staticRenderFns } from "./lbbpr-table.vue?vue&type=template&id=caa48ac6"
import script from "./lbbpr-table.vue?vue&type=script&lang=js"
export * from "./lbbpr-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports